import { types } from '../types/types';

const initialState = [];

export const individualAreasReducer = (state = initialState, action) => {
	switch (action.type) {
		case types.setIndividualAreas:
			return action.payload;

		case types.cleanIndividualAreas:
			return initialState;

		default:
			return state;
	}
};
